import React from 'react'
import EventCard from './EventCard'

export default function EventPast(props) {
  // const events = [1, 2, 3]; // Array to iterate 5 times

  return (
    (props.Events.length === 0) ?
      <div className="event-list">
        <h1>No Past Events</h1>
      </div>
      :
      <div className="event-list">
        {props.Events.map(event => (
          <EventCard key={event._id} day={event.date.split('-')[0]} date={event.date.split('-')[1]} month={event.date.split('-')[2]} time={event.time} venue={event.venue} contact={event.contacts} title={event.title} description={event.description} isPast={false} />
        ))}
      </div>
  );
}
